<div class="container">
  <div class="page">
    <div class="page-header">
      <h1 class="page-title">
        {{'Meet the Team' | translate}}
      </h1>
    </div>

    <div class="page-body">

      <div class="content-wrapper">

        <div class="content">
          <div class="entry-content">
            <p><strong>Wat is Meet the Youngsters?</strong></p>
            <p>Meet the Youngsters is hét online carrière platform voor young professionals, studenten en alumni in Zuidoost Nederland. Het carrière platform dat je de mogelijkheid biedt om in contact te komen met innovatieve en inspirerende werkgevers.</p>
            <p>Het aanbod aan uitdagende stageplekken, traineeships en startersbanen biedt jou als jong talent gigantische mogelijkheden. Kortom: zou je graag je carrière willen starten en willen weten waar je kansen liggen? Meld je dan nu aan, creëer je persoonlijke profiel en ga aan de slag!</p>
            <p><strong>Hoe werkt Meet the Youngsters?</strong></p>
            <ol>
              <li>Je maakt eerst een persoonlijk profiel aan op het platform. Dit doe je door te klikken op ‘start hier’ op de homepage.</li>
              <li>Vul je profiel zo goed mogelijk in (denk bijvoorbeeld aan welke opleidingen je gevolgd hebt, opgedane werkervaring en vakgebieden waar je interesse in hebt).</li>
              <li>Via dit profiel word je gematched met bedrijven die aansluiten bij jouw beroepsinteresses en studie. Dus hoe completer je profiel, hoe beter de matches zullen zijn!</li>
              <li>Als je interesse hebt om in contact te komen met een werkgever stuur je een netwerkverzoek. Andersom kan een bedrijf ook interesse in jou tonen.</li>
              <li>Mocht de interesse wederzijds zijn, dan kom je in elkaars netwerk.</li>
              <li>Vanuit deze positie kun je contact met elkaar opnemen en je carrière uitstippelen bij een van de topwerkgevers.</li>
            </ol>
            <p><strong>Hoe zijn wij ontstaan?</strong></p>
            <p>Meet the Youngsters is ontstaan vanuit het project Limburg Magnet. Limburg Magnet is in 2014 geïnitieerd door de Limburgse Werkgevers Vereniging en wordt inmiddels breed ondersteund door vertegenwoordigers vanuit de Triple Helix (onderwijs, bedrijfsleven, overheid). Dankzij de steun van MKB-Limburg, Keyport 2020, Limburg Economic Development en de LLTB kan dit project mogelijk gemaakt worden. Sinds eind 2017 gaan Limburg Magnet en het platform Brainport2020Career verder onder de naam Meet the Youngsters.</p>
            <p><strong>Meet the Talents B.V.</strong></p>
            <p>De eerste versie van het Meet the Youngsters carrière-platform is ontwikkeld door Soapbox. Het carrière-platform is vervolgens verder ontwikkeld door Meet the Talents. Meet the Talents bouwt communities op de arbeidsmarkt en helpt bedrijven met hun employer branding.</p>
            <p><strong>Contact</strong></p>
            <p>Wil je meer weten over Meet the Youngsters en de mogelijkheden van het platform? Neem dan direct contact met ons op:</p>
            <ul>
              <li>Email: info&#64;meettheyoungsters.nl</li>
              <li>Kantoor: +31 6 83 42 06 65</li>
              <li>Adres:<br>Meet the Talents B.V.<br>a.v. Meet the Youngsters<br>Avenue Ceramique 300<br>6221 KX Maastricht</li>
            </ul>

            <div class="form mb-4">

              <div class="form-group">
                <label>{{'Name' | translate}}</label>
                <input type="text" class="form-control" [(ngModel)]="form.name" />
              </div>

              <div class="form-group">
                <label>{{'Email' | translate}}</label>
                <input type="text" class="form-control" [(ngModel)]="form.email" />
              </div>

              <div class="form-group">
                <label>{{'Subject' | translate}}</label>
                <input type="text" class="form-control" [(ngModel)]="form.subject" />
              </div>

              <div class="form-group">
                <label>{{'Message' | translate}}</label>
                <textarea class="form-control" rows="5" [(ngModel)]="form.message"></textarea>
              </div>

              <div class="btn-toolbar flex-grow-1 align-items-end justify-content-end">

                <div class="btn-group align-content-end align-self-end">
                  <button class="btn btn-primary ">
                    {{'Send' | translate}}
                  </button>
                </div>

              </div>

            </div>

            <h2>Team Meet the Youngsters</h2>



          </div>

        </div>

      </div>


    </div>
  </div>
</div>
